import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

const PILLARS = [
  {
    title: 'PUBLIEZ',
    desc: "Créez votre course en 5 min. Parcours, distances, tarifs, règlement, parcours GPX. Intégration Strava.",
    stat: '5 min',
    statLabel: 'pour publier',
    color: '#caff00',
  },
  {
    title: 'REMPLISSEZ',
    desc: "Visibilité native sur 180 000 coureurs. Newsletter, carte, notifications push — on s'occupe du marketing.",
    stat: '+42%',
    statLabel: 'inscriptions moyennes',
    color: '#00e5ff',
  },
  {
    title: 'ENCAISSEZ',
    desc: 'Paiements sécurisés, versement hebdomadaire, commission transparente de 10% tout compris. Facture auto.',
    stat: '10%',
    statLabel: 'commission tout inclus',
    color: '#ff2d9e',
  },
];

const CTASection = () => {
  return (
    <section
      id="organisateurs"
      className="relative border-t border-white/10 py-24 md:py-32 overflow-hidden scroll-mt-20"
      style={{
        background:
          'radial-gradient(ellipse at 20% 50%, rgba(255,45,158,0.08), transparent 60%)',
      }}
    >
      <div aria-hidden className="absolute inset-0 pointer-events-none">
        {Array.from({ length: 8 }).map((_, i) => (
          <div
            key={i}
            className="absolute -left-[10%] -right-[10%] h-px"
            style={{
              top: `${8 + i * 12}%`,
              background: `linear-gradient(90deg, transparent, ${
                i % 2 ? 'rgba(255,45,158,0.18)' : 'rgba(255,255,255,0.04)'
              }, transparent)`,
              transform: 'skewY(-2deg)',
            }}
          />
        ))}
      </div>

      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        <div className="text-center mb-14 md:mb-16">
          <div className="font-mono text-[11px] tracking-[0.14em] uppercase text-energy mb-4">
            // CHAPITRE CINQ · POUR LES ORGANISATEURS
          </div>
          <h2 className="m-0 leading-[0.92]">
            <span className="font-display italic uppercase -skew-x-6 inline-block text-[52px] md:text-[76px] lg:text-[104px] text-foreground">
              TU ORGANISES.
            </span>
            <br />
            <span className="font-display italic uppercase -skew-x-6 inline-block text-[52px] md:text-[76px] lg:text-[104px] text-muted-foreground">
              ON REMPLIT LA
            </span>
            <br />
            <span
              className="font-display italic uppercase -skew-x-6 inline-block text-[52px] md:text-[76px] lg:text-[104px] text-transparent bg-clip-text"
              style={{ backgroundImage: 'linear-gradient(90deg, #caff00 0%, #f8ff3a 35%, #ff7a1a 65%, #ff2d9e 100%)' }}
            >
              LIGNE DE DÉPART.
            </span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mb-14">
          {PILLARS.map((p) => (
            <div
              key={p.title}
              className="relative p-7 md:p-8 rounded-2xl border border-white/10 bg-white/[0.03]"
            >
              <div
                className="font-display italic leading-none text-[44px]"
                style={{ color: p.color }}
              >
                {p.stat}
              </div>
              <div className="text-[10px] uppercase tracking-[0.12em] text-muted-foreground mt-1">
                {p.statLabel}
              </div>
              <div className="font-display italic uppercase text-2xl md:text-[26px] text-foreground mt-6">
                {p.title}.
              </div>
              <p className="mt-3 text-[13px] leading-relaxed text-muted-foreground">{p.desc}</p>
            </div>
          ))}
        </div>

        <div className="flex flex-wrap gap-3 justify-center">
          <Button
            asChild
            className="rounded-full bg-energy text-energy-foreground hover:bg-energy/90 px-6 py-5 text-[13px] font-bold uppercase tracking-[0.08em] gap-2"
          >
            <Link to="/organisateur/inscription">
              Publier une course · gratuit
              <ArrowRight className="w-4 h-4" />
            </Link>
          </Button>
          <Button
            variant="outline"
            asChild
            className="rounded-full border-white/20 text-foreground hover:bg-white/5 px-6 py-5 text-[13px] font-bold uppercase tracking-[0.08em]"
          >
            <Link to="/contact">Parler à un humain</Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
